import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';
import { toObsContent } from '~/components/Content/Content.hooks';
import { BaseError } from '~/components/Error/BaseError';
import { SaleNftModel } from '~/components/Nft/Nft.hooks';

export type MarketplaceNftsResponse = { responseData: { nftList: SaleNftModel[] } };
export type MarketplaceNftCategoryType = 'CITIZEN' | 'PET' | undefined;
export const marketplaceNftsUrl = '/api/citizen/v1/home/market/nfts';
export type MarketplaceNftsParams = {
  size?: number;
  categoryType?: MarketplaceNftCategoryType;
};
export const transformData = (data: SaleNftModel) => ({
  ...data,
  ...toObsContent(data, { thumbnailId: 'png_s300x300' }),
});
export const getMarketplaceNfts = async (params?: MarketplaceNftsParams) => {
  const {
    data: {
      responseData: { nftList },
    },
  } = await axios.get<MarketplaceNftsResponse>(marketplaceNftsUrl, { params });

  if (nftList.length === 0) {
    throw new BaseError(`${params?.categoryType || 'NFT'}_EMPTY`);
  }

  return nftList.map(transformData);
};
export const useMarketplaceNfts = (
  params?: MarketplaceNftsParams,
  options?: UseQueryOptions<SaleNftModel[], BaseError>
) =>
  useQuery<SaleNftModel[], BaseError>(
    ['marketplaceNfts', params],
    () => getMarketplaceNfts(params),
    {
      initialData: [],
      refetchOnWindowFocus: false,
      ...options,
    }
  );
